import React, { useState } from 'react';
import './BoardList.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import Button from '../comm/HongButton';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedList, setInitialPage, setSelectedListFile } from "../reduxToolkit/reduxBoard";
import BoardDetail from './BoardDetail';
import BoardWrite from './BoardWrite';


const BoardList = ({currentItems, setModalOpen, setSelectedItem}) => {
    const boardTitle = useSelector(state => state.reduxStoreBoard.boardTitle);
    const isAdmin = useSelector(state => state.reduxStoreBoard.isAdmin);
    const dispatch = useDispatch();
    const [isModal, setIsModal] = useState(false);
    const [isModal_boardWrite, setIsModal_boardWrite] = useState(false);
     
           
    const onBoardWrite = () => {
          setIsModal_boardWrite(true);
    };

      
      const onRowClick = (item) => {
      
        dispatch(setSelectedList({ 
            sno:item.sno, 
            title:item.title, 
            category:item.category,
            content:item.content, 
            date:item.date,
            kind:item.kind,
            code:item.code
          }));

          setIsModal(true);

      }


    //=====================================================================================
    return (
      <>
      <div className='frame_boardList'>    
          {<div className="BoardList">
              <div className='box_title'>
                  {/* <h2 className='title'>{boardTitle.text}</h2> */}
                 {isAdmin &&  <Button className='h-btn-green' onClick={onBoardWrite}>글쓰기</Button> }
              </div>
   
              <table>
                  <thead>
                      <tr>
                          <th>번호</th>
                          <th>제목</th>
                          <th>날짜</th>        
                      </tr>
                  </thead>
                  <tbody>
                      {currentItems.map(item => (
                          <tr key={item.sno} onClick={() => onRowClick(item)}>
                              <td>{item.category}</td>
                              <td>{item.title}</td>
                              <td>{item.date}</td>
                          </tr>
                      ))}
                  </tbody>
              </table>
            
            </div>
            
            }
     </div> 

     {isModal && <div className='box_modal'>
                  <BoardDetail setIsModal={setIsModal}/>
      </div> }     

      {isModal_boardWrite && 
      <div className='box_modal'>
                  <BoardWrite setIsModal_boardWrite={setIsModal_boardWrite}/>
      </div> }    

      

     </>  


    );
  };
  
export default BoardList;
